import { type IEmailValidatorResponse } from '@mahawi/eshop-rabbit';

export const isEmailAccepted = (result: IEmailValidatorResponse): boolean =>
  result.isValid !== false && !result.isDisposable;
